module.exports = __webpack_public_path__ + "a1647b45ebc0d206023f9de9cf96fa31.png";